import { AbstractControl, FormGroup, FormArray } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class ReactiveFormsService {
    /**
     * Gets all errors
     * @param control AbstractControl
     * @returns { [key: string]: any } | null
     */
    static getAllErrors(
        control: AbstractControl
    ): { [key: string]: any } | null {
        const errors =
            control instanceof FormGroup || control instanceof FormArray
                ? this.getAllErrors(control)
                : control.errors;
        return errors ? errors : null;
    }

    /**
     * Errors message
     * @param control AbstractControl
     * @returns string
     */
    static errorMessage(control: AbstractControl): string | null {
        for ( const propertyName in control.errors ) {
            if (
                control.errors.hasOwnProperty(propertyName) &&
                control.touched
            ) {
                return this.getValidatorErrorMessage(
                    propertyName,
                    control?.errors[propertyName]
                );
            }
        }
        return null;
    }

    /**
     * Gets validator error message
     * @param validatorName string
     * @param [validatorValue] any
     * @returns string
     */
    static getValidatorErrorMessage(
        validatorName: string,
        validatorValue?: any
    ): string {
        const config: any = {
            required: '(*) El campo es obligatorio.',
            email: 'El correo electronico no es valido.',
            invalidPassword: 'Contraseña invalida. La contraseña debe tener al menos 6 caracteres y contener un número.',
            minlength: `Caracteres mínimos permitidos ${ validatorValue.requiredLength }.`,
            maxlength: `Máximo de caracteres permitidos ${ validatorValue.requiredLength }.`,
            isnumber: 'Solo números permitidos.',
            numberInvalid: 'Solo números permitidos.',
            isdecimal: 'Solo se permiten números enteros y decimales.',
            pattern: 'El valor ingresado no es valido.',
            isequals: 'El valor ingresado no es valido.',
            match: 'Ingrese el mismo valor nuevamente.',
            digits: 'El valor ingresado no es correcto, solo se permiten números',
            property: 'EL valor ingreso no está permitido.',
            arrayLength: 'Candiad de datos seleccionados no permitidos',
            ruc: 'EL ruc ingresado no es validado.',
            confirmPasswordValidator: 'La contraseña y la confirmación de contraseña deben coincidir.',
            digitalWalletNotBuy: `No puedes seleccionar ${validatorValue.name} para una ${validatorValue.type}.`,
            minAmountValid: `No puede seleccionar para montos menores a ${validatorValue.minAmount}.`,
            digitalWalletMaxAmount: `No puede seleccionar para montos mayores a ${validatorValue.maxAmount}.`,
            phoneInvalid: 'El número de teléfono ingresado no es válido.',
            invalidAgeFormat: 'La fecha debe estar en formato ISO (YYYY-MM-DDTHH:MM:SSZ).',
            invalidAgeDate: 'La fecha proporcionada no es válida.',
            underage: 'Debe ser mayor de 18 años.',
        };
        return config[validatorName];
    }
}
